import React from 'react'
import { useSelector } from "react-redux";
import {Box, Link} from "@mui/material";
import {buttonContained} from "./ButtonContained";
import LoadingSpinner from "./LoadingSpinner";
import {modalInnerStyles} from "./basicModalStyles";

export default function SetupModalFooter({extraInfoLabel, openInNewTab, buttonLabel, disabled, loading, extraInfoLink}) {
	const {SolidButton} = buttonContained;
	const msgSourceLink = useSelector((state) => state.msgSources.msgSourceLink.msgSourceLink);

	return (
		<Box sx={modalInnerStyles.buttonContainer}>
			<Box sx={modalInnerStyles.buttonLeft}>
				{ (msgSourceLink || extraInfoLink) && (
					<Link 
						href={msgSourceLink || extraInfoLink}
						sx={styles.link}
						target={openInNewTab ? '_blank' : '_self'}
						rel="noopener"
						underline="none">
						{extraInfoLabel || 'View setup instructions'}
					</Link>
				) }
			</Box>
			<Box sx={modalInnerStyles.buttonRight}>
				{loading && (<Box sx={modalInnerStyles.loadingSpinner}><LoadingSpinner /></Box>)}
				<SolidButton label={buttonLabel} disabled={disabled} />
			</Box>
		</Box>
	)
}

const styles = {
	link: {
		color: '#125e82',
		fontFamily: 'LarsseitMedium',
		':hover': { color: '#125e82', backgroundColor: 'unset' }
	}
}